import { useSnapshot } from "valtio";
import { clientDashboardEvents, TreeNode } from "../clientDashboardEvents";
import { STATUS_LABEL, daysRemaining, findCampaign, formatDate } from "../campaignDates";

/**
 * The selected campaign's flight, shown only when the dashboard is narrowed to one campaign
 * (MPN-1964 AC5). With several campaigns in scope there is no single start or end to show,
 * and the Campaign selector already carries each one's dates.
 *
 * An unscheduled campaign still gets the card, with its name and status and no dates. The
 * card is the only place the page says which campaign is in scope and what state it is in,
 * and dropping all of that because there is no schedule to print leaves a client reading a
 * dashboard with no idea what they are looking at.
 */
export default function CampaignDates() {
    const snap = useSnapshot(clientDashboardEvents);
    const campaign = findCampaign(snap.filterTree as TreeNode[], snap.launch);
    if (!campaign) return null;

    const start = formatDate(campaign.start_date);
    const end = formatDate(campaign.end_date);
    const remaining = daysRemaining(campaign);

    return (
        <div className="campaign-dates">
            <div className="campaign-dates__name">{campaign.name}</div>
            <div className="campaign-dates__facts">
                {start && (
                    <span className="campaign-dates__fact">
                        <span className="campaign-dates__label">Starts</span>
                        {start}
                    </span>
                )}
                {end && (
                    <span className="campaign-dates__fact">
                        <span className="campaign-dates__label">Ends</span>
                        {end}
                    </span>
                )}
                {!start && !end && (
                    <span className="campaign-dates__fact campaign-dates__label">Not scheduled</span>
                )}
                {remaining !== null && campaign.status === "LIVE" && (
                    <span className="campaign-dates__fact">
                        <span className="campaign-dates__label">Days remaining</span>
                        {remaining}
                    </span>
                )}
                {campaign.status && (
                    <span className="campaign-dates__fact campaign-dates__fact--status">
                        {STATUS_LABEL[campaign.status]}
                    </span>
                )}
            </div>
        </div>
    );
}
